// Exitosos
export const SAVED_SUCCESSFULLY = 'Se guard\u00F3 correctamente';
export const UPDATED_INFORMATION = 'Informaci\u00F3n Actualizada';
export const EDITED_SUCCESSFULLY = 'Registro editada exitosamente';
export const DELETED_SUCCESSFULLY = 'Registro eliminado exitosamente';
export const PROFILE_UPDATED_SUCCESSFULLY = 'Perfil actualizado correctamente';
export const CHANGES_HAVE_BEEN_SAVED = 'Se han guardado los cambios';
export const PROFILE_CHANGES_HAVE_BEEN_SAVED =
  'Se han guardado los cambios en el perfil';
export const DOCUMENT_HAS_BEEN_DOWNLOADED = 'Se ha descargado el documento';
export const LOAD_SUCCESSFULLY = 'Se ha cargado correctamente';
export const TABLE_COPIED_SUCCESSFULLY = 'Tabla copiada en el portapapeles';

// Informativos
export const SAVING_INFORMATION = 'Guardando la informaci\u00F3n';
export const DOWNLOADING_DOCUMENT = 'Descargando documento...';
export const UPLOADING_FILE = 'Subiendo archivo, Aguarde por favor.';
export const UPLOADING_FILES = 'Subiendo archivo(s). Aguarde por favor.';
export const LOADING_PROCESS_STARTED =
  'Se ha iniciado el proceso de carga de tu archivo';
export const NO_INFORMATION = 'No hay informaci\u00F3n para mostrar';
export const NO_DATA_TO_DOWNLOAD = 'No se encontraron datos para descargar';

// Error
export const ERROR_INFO = 'Error obteniendo informaci\u00F3n';
export const DEFAULT_ERROR = 'Ha ocurrido un error inesperado';
export const ERROR_REQUIRED = 'Es necesario ingresar un valor';
export const ERROR_REQUIRED_SELECT = 'Es necesario seleccionar un valor';
export const ERROR_NUMERIC_VALUES = 'Solo se permiten valores numéricos';
export const ERROR_END_DATE = 'Fecha final no puuede ser menor a fecha inicial';
export const ERROR_DATE_AFTER_MAX =
  'La fecha no debe ser posterior a la fecha máxima';
export const ERROR_IN_SOME_FIELDS = 'Algunos campos tienen errores';
export const ERROR_TRYING_TO_SAVE =
  'Ocurri\u00F3 un error al intentar guardar la informaci\u00F3n';
export const ERROR_TRYING_TO_DELETE =
  'Ocurri\u00F3 un error al intentar eliminar la información';
export const ERROR_TRYING_TO_DOWNLOAD =
  'Ocurri\u00F3 un error al intentar descargar el documento';
export const ERROR_COPYING_TABLE = 'No se pudo copiar la tabla';
